module.exports = __webpack_public_path__ + "static/media/sm58.eb952d04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProAudioPage/assets/sm58.jpg
// module id = 530
// module chunks = 0